module.exports = __webpack_public_path__ + "static/img/qyjr60.38e3dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qyjr60.png
// module id = kUJo
// module chunks = 73